// User Information

export const GET_USER_DETAILS_SUCCESS = "userinformation/GET_USER_DETAILS_SUCCESS";
export const GET_USER_DETAILS_FAILURE = "userinformation/GET_USER_DETAILS_FAILURE";

